<template>
  <div class="l_popup animation__background">
    <div class="l_popup__panel animation__popup">
      <h2 class="c_title">{{ title }}</h2>
      <div class="l_popup__text">
        <p class="c_message">{{ message }}</p>
        <div class="l_popup__button">
          <UIButton :label="this.label" @click="tapSubmit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
export default {
  name: 'Alert',
  components: {
    UIButton
  },
  props: {
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    label: { type: String, default: '' }
  },
  methods: {
    tapSubmit: function () {
      this.$emit('close')
      this.$emit('submit')
    }
  }
}
</script>

<style scoped>
.l_popup {
  position: absolute;
  top: 0;
  left: 0;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.l_popup__panel {
  position: relative;
  border-radius: 6px;
  border: none;
  background-color: #ffffff;
  width: 280px;
  padding: 20px;
}

.c_title {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  font-weight: bold;
  line-height: 1.29;
  letter-spacing: normal;
  color: #66160E;
  margin: 10px 10px 0px;
  text-align: center;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 0;
}

.c_message {
  margin: 10px 0;
  font-size: 14px;
}

/* close button  */
.l_button__close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%, 20%, 50%, 80% {
    transform: scale(1.0, 1.0);
  }
  40% {
    transform: scale(0.93, 0.93);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
  100% {
    transform: scale(1.0, 1.0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0.0;
  }
  100% {
    opacity: 1.0;
  }
}
</style>
